import { domain } from "../auth/domain";

const getAuthHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `JWT ${localStorage.getItem("accessToken")}`,
});

const handleResponse = async (response) => {
  if (response.status === 204) {
    return null;
  }
  if (response.ok) {
    return response.json();
  }
  const error = await response.json().catch(() => ({}));
  const detail = error?.detail || "Request failed";
  throw new Error(detail);
};

export const fetchWithdrawalRequirements = async () => {
  const response = await fetch(`${domain}profiles/member-withdrawals/requirements/`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const fetchMyWithdrawalRequest = async () => {
  const response = await fetch(`${domain}profiles/member-withdrawals/me/`, {
    headers: getAuthHeaders(),
  });
  if (response.status === 404) {
    return null;
  }
  return handleResponse(response);
};

export const submitWithdrawalRequest = async (payload) => {
  const response = await fetch(`${domain}profiles/member-withdrawals/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};

export const fetchWithdrawalRequests = async () => {
  const response = await fetch(`${domain}profiles/member-withdrawals/`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const reviewWithdrawalRequest = async (requestId, payload = {}) => {
  const response = await fetch(`${domain}profiles/member-withdrawals/${requestId}/approve/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};
